import { isTierUpgradeCampaignPath } from 'loyalty/tierUpgradeCampaign/tierUpgradeCampaignRoutes'

// Campaign landing pages (by slug) that showed their own success modal in this tab
const heldCampaignSlugs = new Set<string>()

/**
 * Holds the global rewards notification for a tier upgrade while the customer stays on this
 * campaign's landing page, which is celebrating it with its own success modal.
 */
export function holdTierUpgradeNotificationOnCampaignPage(slug: string): void {
  heldCampaignSlugs.add(slug)
}

/** True while on a landing page that is celebrating its own upgrade. */
export function isTierUpgradeNotificationHeld(pathname: string): boolean {
  return [...heldCampaignSlugs].some(slug => isTierUpgradeCampaignPath(pathname, slug))
}

/** Releases every hold, once the customer has left the landing page. */
export function releaseTierUpgradeNotificationHolds(): void {
  heldCampaignSlugs.clear()
}
